import React, { useContext }  from 'react'
import ResinousSystemType from './ResinousSystemType'
import { AppContext } from '../../../App'
// import ProductsNotFound from '../../productsNotFound'
import Loading from '../../loading'

export default function ResinousSystemTypeList() {
   const { resinousSystemTypes, productOptionsSelected } = useContext(AppContext)
   const { productOptions } = productOptionsSelected
   const system = productOptions[2]

   return (
      // Render the system types in order as specified in systemTypeOrder.
       resinousSystemTypes.length > 0 ? (
         <div className="panel panel-primary list-items">
               <div className="panel-heading">
                  <h4 className="panel-title">Select a { system } System Type</h4>
               </div>
               <div className="panel-body">
               {
                       resinousSystemTypes.map((rstr, index) => {
                     return <ResinousSystemType key={ index + "_" + rstr.name } productIndex={index} {...rstr} />
                  })
               }
               </div>
         </div>
      ) : (
         // If the resinous system types didn't get reorderd because none match from the explicit list, just render them anyway in standard order.
         resinousSystemTypes.length > 0 ? (
               <div className="panel panel-primary list-items">
                  <div className="panel-heading">
                     <h4 className="panel-title">Select a { system } System Type</h4>
                  </div>
                  <div className="panel-body">
                  {
                     resinousSystemTypes.map((rst, index) => {
                           return <ResinousSystemType key={ index + "_" + rst.name } productIndex={index} {...rst} />
                     })
                  }
                  </div>
               </div>
         ) : (
            <Loading type="resinous system types" /> 
         ) 
      )
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousSystemTypeList.js